"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { PrintDropdown } from "~/components/ui/print-dropdown-eon";
import ShareDropdown from "~/components/ui/share-dropdown-eon";
import { WatchJobButton } from "~/components/ui/watch-job-button-eon";
import { toSimilarJob } from "~/lib/utils/to-similar-job";
import { env } from "~/setup/env";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import { FormattedTitle } from "../../ad/formatted-title-eon";

// Hide detail rows whose value is empty or an explicit "Not specified" placeholder
const hasValue = (value: string | undefined | null): value is string => {
  const trimmed = value?.trim();
  return Boolean(trimmed) && trimmed?.toLowerCase() !== "not specified";
};
export default function HeaderImageEonUk(t0) {
  const $ = _c(43);
  const {
    job
  } = t0;
  const t = useLanguage();
  const assetBase = `${env.NEXT_PUBLIC_ASSET_URL}images/header/subclients/uk/`;
  const headerImageSrc = job.data.source?.toLowerCase().includes("oracle") ? job.content.headerImage : `${assetBase}${job.content.headerImage}`;
  let t1;
  if ($[0] !== headerImageSrc || $[1] !== job.content.headerVideo) {
    t1 = <div className="relative aspect-video lg:aspect-auto">{job.content.headerVideo ? <video autoPlay={true} className="h-full max-h-[700px] w-full object-cover object-left" loop={true} muted={true} playsInline={true} src={`${assetBase}${job.content.headerVideo}`} suppressHydrationWarning={true} /> : <CustomImage className="h-full max-h-[700px] object-cover object-left" height={1070} sizes="(max-width: 1024px) 100vw, 60vw" src={headerImageSrc} width={2000} />}</div>;
    $[0] = headerImageSrc;
    $[1] = job.content.headerVideo;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== job.data.title) {
    t2 = <div className="text-lg xl:text-xl"><h1 className="mt-4 font-headline text-3xl xl:text-4xl" data-source="job"><FormattedTitle input={job.data.title} /></h1></div>;
    $[3] = job.data.title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== job.data.contract) {
    t3 = hasValue(job.data.contract) && <li className="flex w-full items-center gap-x-3"><CustomImage className="mt-1" height={34} src="images/icons/file_white.svg" width={34} /><span data-source="job">{job.data.contract}</span></li>;
    $[5] = job.data.contract;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== job.data.remote) {
    t4 = hasValue(job.data.remote) && <li className="flex w-full items-center gap-x-3"><CustomImage className="mt-1" height={34} src="images/icons/pc_mac_white.svg" width={34} /><span data-source="job">{job.data.remote}</span></li>;
    $[7] = job.data.remote;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CustomImage className="mt-1" height={34} src="images/icons/tag.svg" width={34} />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== job.data.idClient || $[11] !== t.jobad_details_jobNumber) {
    t6 = <li className="flex w-full items-center gap-x-3">{t5}<span data-source="lc">{t.jobad_details_jobNumber}: {job.data.idClient}</span></li>;
    $[10] = job.data.idClient;
    $[11] = t.jobad_details_jobNumber;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== job.content.compensation) {
    t7 = hasValue(job.content.compensation) && <li className="flex w-full items-center gap-x-3"><CustomImage className="mt-1" height={34} src="images/icons/payment.svg" width={34} /><span data-source="job">{job.content.compensation}</span></li>;
    $[13] = job.content.compensation;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <CustomImage className="mt-1" height={34} src="images/icons/home.svg" width={34} />;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== job.data.company) {
    t9 = <li className="flex w-full items-center gap-x-3">{t8}<span data-source="job">{job.data.company}</span></li>;
    $[16] = job.data.company;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t3 || $[19] !== t4 || $[20] !== t6 || $[21] !== t7 || $[22] !== t9) {
    t10 = <ul className="flex flex-col text-lg md:mt-2 lg:mt-8 xl:text-xl">{t3}{t4}{t6}{t7}{t9}</ul>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== job) {
    t11 = <ShareDropdown job={job} />;
    $[24] = job;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <PrintDropdown asButton={true} />;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== job.data) {
    t13 = toSimilarJob(job.data);
    $[27] = job.data;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13) {
    t14 = <WatchJobButton jobData={t13} />;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t11 || $[32] !== t14) {
    t15 = <section className="my-8 grid grid-cols-3 gap-4 print:hidden [&_button]:bg-background [&_button]:text-primary [&_button]:hover:brightness-90">{t11}{t12}{t14}</section>;
    $[31] = t11;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t10 || $[35] !== t15) {
    t16 = <div>{t10}{t15}</div>;
    $[34] = t10;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t16 || $[38] !== t2) {
    t17 = <div className="h-full px-6 py-2 lg:max-w-[680px] lg:justify-self-start lg:px-10"><div className="flex h-full flex-col justify-between md:gap-6 xl:justify-end xl:gap-8">{t2}{t16}</div></div>;
    $[37] = t16;
    $[38] = t2;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t1 || $[41] !== t17) {
    t18 = <section className="w-full bg-primary text-white lg:flex lg:justify-center print:hidden"><div className="grid w-full auto-cols-fr lg:auto-cols-[2fr_1fr] lg:grid-flow-col xl:auto-cols-[3fr_2fr]">{t1}{t17}</div></section>;
    $[40] = t1;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  return t18;
}